import BillingSummaryReportEditResultConfigController from './edit_config_controller/BillingSummaryReportEditResultConfigController'
import {ReportType} from './constants'
import OldReportMediator from './OldReportMediator'
import ReportPrintableHeadersBuilder from './ReportPrintableHeadersBuilder'

export default function BillingSummaryReportMediator ()
{
    this.constructor = BillingSummaryReportMediator;
}

BillingSummaryReportMediator.prototype = new OldReportMediator();

BillingSummaryReportMediator.prototype.init = function ( config )
{
    OldReportMediator.prototype.init.call(this, config);

    return this;
};

BillingSummaryReportMediator.prototype.getReportType = function()
{
    return ReportType.BILLING_SUMMARY;
};

BillingSummaryReportMediator.prototype.initEditConfigController = function( config )
{
    var self = this;
    return new BillingSummaryReportEditResultConfigController().init(
            {
                reportParameters: config.reportParameters,
                cpList: config.cpList,
                customersWithMaIds: config.customersWithMaIds,
                projectsWithMaIds: config.projectsWithMaIds,
                changeCallback: function(){ self.changeParametersCallback(); }
            } );
};

BillingSummaryReportMediator.prototype._populateHeadersArray = function( headersArray ) {
    this.printableHeadersBuilder.addBillableReportTypeParamsStringToArray( this.reportParameters.reportType, headersArray ); //report type
    this.printableHeadersBuilder.addCPSelectionParamsStringToArray( this.reportParameters.customersProjectsSelection, headersArray ); //customers and projects
    this.printableHeadersBuilder.addBillableTaskSelectionParamsStringToArray( this.reportParameters.reportInfo, headersArray ); //tasks
    this.printableHeadersBuilder.addTimeApprovalStatusToArray( this.reportParameters.timeApprovalStatus, headersArray ); //time approval status
};

BillingSummaryReportMediator.prototype.initPrintableHeadersBuilder = function ( config ) {
    return new ReportPrintableHeadersBuilder().init(
            {
                reportParameters: config.reportParameters,
                cpList: config.cpList,
                isFilteredByAssignments: config.isFilteredByAssignments
            }
    );
};



// WEBPACK FOOTER //
// ./web/js/reports/BillingSummaryReportMediator.js